import axios from 'axios'
import store from '../store'
import { Notify } from 'vant'
const service = axios.create({
  baseURL: '/api', // api 的 base_url
  timeout: 60000 // 10秒请求超时
})

// 请求拦截
service.interceptors.request.use(
  req => {
    const token = localStorage.getItem('token')
    if (token && token !== 'undefined') {
      req.headers.token = token
    }
    return req
  },
  err => {
    console.log('请求拦截报错', err)
    return err
  }
)
// 响应拦截
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { code, errMsg } = error.response.data
    if (code === 1000) {
      store.dispatch('user/logout').then(() => {
        sessionStorage.setItem('responseCode', 1000)
        location.reload()
      })
    } else if (code && errMsg) {
      Notify({
        message: errMsg,
        type: 'warning',
        duration: 5 * 1000
      })
    } else if (error.response.data instanceof Blob) {
      const reader = new FileReader()
      reader.readAsText(error.response.data, 'utf-8')
      reader.onload = () => {
        Notify({
          message: JSON.parse(reader.result).errMsg,
          type: 'danger',
          duration: 5 * 1000
        })
      }
    } else {
      // 服务器异常
      Notify({
        message: '服务器崩溃了~~',
        type: 'danger',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
